import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { Assignment } from 'src/features/pricingPlans/types';

const RESOURCE = '/parkings/:parkingId/pricing-plans/normal/assign-specific-purpose/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    planId: z.nullable(z.number()),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
    code: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<Assignment> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as UPDATE_SPECIFIC_PURPOSE_ASSIGNMENT_RESOURCE,
    useMutationHook as useUpdateSpecificPurposeAssignment,
    formSchema as updateSpecificPurposeAssignmentFormSchema,
};
export type {
    DTO as UpdateSpecificPurposeAssignmentDTO,
    FormSchemaValues as UpdateSpecificPurposeAssignmentFormSchemaValues,
};
